import { Directive, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { fromEvent, Subject, Subscription, throttleTime } from "rxjs";
import { ConfigService } from "src/app/services/config/config.service";

@Directive({
    standalone: true,
    selector: '[appThrottleSubmit]',
})

export class ThrottleSubmitDirective implements OnInit, OnDestroy {
    @Input() throttleTime?: number;
    @Output() throttleSubmit = new EventEmitter();

    private clicks = new Subject();
    private subscription: Array<Subscription> = [];
    private defaultThrottleTime = 2000;

    constructor(private elem: ElementRef, private config: ConfigService) {
        this.subscription.push(
            fromEvent(this.elem.nativeElement, 'submit')
                .subscribe((event: Event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    this.clicks.next(event);
                })
        );
    }

    ngOnInit(): void {
        let time = Number(this.config.getConfig().FEATURE_THROTTLE_SUBMIT_TIME);
        if (!time) {
            time = this.throttleTime ?? this.defaultThrottleTime;
        }
        this.subscription.push(
            this.clicks.pipe(throttleTime(time))
                .subscribe(e => this.throttleSubmit.emit(e))
        );
    }

    ngOnDestroy() {
        this.subscription.forEach(e => e.unsubscribe());
    }
}